import axios from './index';

/**
 * APIs
 */
// 获取账号列表
export function accounts(params: AccountsParams) {
    return axios<AccountsListRes>('/v1/accounts', {
        method: 'get',
        params,
    });
}

// 创建账号
export function cAccount(data: CAccountData) {
    return axios<ResType<AccountsResponse>>('/v1/accounts', {
        data,
        method: 'post',
    });
}

// 获取账号详情
export function rAccount(id: string) {
    return axios<ResType<AccountsResponse>>(`/v1/accounts/${id}`, {
        method: 'get',
    });
}

// 更新账号（OpenAPI: PATCH）
export function uAccount(id: string, data: UAccountData) {
    return axios<ResType<AccountsResponse>>(`/v1/accounts/${id}`, {
        data,
        method: 'patch',
    });
}

// 删除账号
export function dAccount(id: string) {
    return axios<ResType>(`/v1/accounts/${id}`, {
        method: 'delete',
    });
}

/**
 * Types（与 OpenAPI 对齐）
 */
import { ResType } from '@/typings/common';

export type AccountsParams = {
    page?: number;
    size?: number;
    account?: string;
    account_fuzzy?: string;
};

export type AccountsListRes = {
    code: number;
    data: AccountsResponse[];
    meta: {
        page?: number;
        size?: number;
        total?: number;
        cursor?: string;
        more?: boolean;
    };
    msg: string;
};

export type AccountsResponse = {
    id: string;
    account: string;
    status: 'Enabled' | 'Disabled';
    version?: string;
    created_at: string;
    updated_at: string;
    deleted_at?: string | null;
    roles?: {
        id: string;
        name: string;
        permissions?: string[];
        status?: string;
    }[];
};

export type CAccountData = {
    account: string;
    password: string;
    status: 'Enabled' | 'Disabled';
    role_ids?: string[];
};

export type UAccountData = {
    account?: string;
    password?: string;
    status?: 'Enabled' | 'Disabled';
    role_ids?: string[];
    version?: string;
    id?: string;
    created_at?: string;
    updated_at?: string;
};

export type RAccountResponse = AccountsResponse;
